module.exports = __webpack_public_path__ + "fonts/Averta-Regular.fd40a6d.ttf";